<div *ngIf="sesionAbierta || esLogin"
  class="language"
  [ngClass]="isProfile ? 'language-profile' : 'language-all'"
  (click)="isOpenLanguage = true"
>
  <img
    [src]="
      currentLanguage === 'es' ? 'assets/img/mex.png' : 'assets/img/usa.png'
    "
  />
</div>

<div class="select-language" *ngIf="isOpenLanguage">
  <div>
    <button
      mat-mini-fab
      color="warn"
      class="crox"
      (click)="isOpenLanguage = !isOpenLanguage"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="select-language-container">
    <div *ngIf="isDashboard">
      <h4>Idioma por defecto de tú página.</h4>
      <span
        >Cuando el publico entre a tu pagina, aparecera el idioma que tu escojas
        en esta opcion.</span
      >
      <mat-radio-group
        [value]="defaultLanguage"
        (change)="changeLanguageDefault($event)"
      >
        <mat-radio-button value="es"
          ><img src="assets/img/mex.png"
        /></mat-radio-button>
        <mat-radio-button value="en" class="ms-3">
          <img src="assets/img/usa.png"
        /></mat-radio-button>
      </mat-radio-group>
    </div>
    <hr *ngIf="isDashboard" />
    <div>
      <h4>Idioma de la página.</h4>
      <mat-radio-group
        [value]="currentLanguage"
        (change)="changeLanguage($event)"
      >
        <mat-radio-button value="es"
          ><img src="assets/img/mex.png"
        /></mat-radio-button>
        <mat-radio-button value="en" class="ms-3">
          <img src="assets/img/usa.png"
        /></mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</div>
